module.exports = __webpack_public_path__ + "static/floralbunnyhamper-3888f33359fe3215c043dcdb23d84fec.jpeg";